module.exports = __webpack_public_path__ + "media/images/iconSettings__okGreen--dark-73fcf26653a62684e63a88090282c785.png";